<template>
  <a
    v-if="!forceStatic"
    :href="path"
    class="tab-link"
    @keyup.enter.prevent.stop="handleLinkClick"
    @click.prevent="handleLinkClick"
  >
    <slot />
  </a>
  <span v-else><slot /></span>
</template>

<script>
export default {
  name: "TabLink",
  props: {
    name: {
      type: String,
      default: "default",
    },
    params: {
      type: Object,
      default: () => {},
    },
    path: {
      type: String,
      default: "",
    },
    forceStatic: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleLinkClick() {
      this.$tabs.open(this.$props);
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-link {
  // -webkit-text-fill-color: $--link-color;   ** airsim comments 2026.09.02 파란 링크 → 검정 통일(피그마 참조) **
  // color: $--link-color;
  -webkit-text-fill-color: $gpro-black; // airsim add 2026.09.02 검정
  color: $gpro-black;
  cursor: pointer;

  &:hover {
    // 클릭 가능 표시는 hover 밑줄로 유지(색은 검정 유지)
    -webkit-text-fill-color: $gpro-black;
    color: $gpro-black;
    text-decoration: underline;
  }
}
</style>
